import { FetchResponseError } from "app/services/fetchService";

type FetchResponseErrorBodyField = "message" | "detail";

type FetchResponseErrorBody = {
    message?: unknown;
    detail?: unknown;
};

/**
 * Sales-API endpoints return a JSON error body on 4xx responses. Scoring uses `message`; signal
 * delete uses `detail`. PUT/DELETE surface the raw `FetchResponseError` whose body has not been
 * consumed yet, so we read the server-provided field here to show it to the user.
 */
export const getFetchResponseErrorMessage = async (
    error: unknown,
    field: FetchResponseErrorBodyField = "message",
): Promise<string | undefined> => {
    if (!(error instanceof FetchResponseError) || !error.response) {
        return undefined;
    }

    try {
        const body = (await error.response.clone().json()) as FetchResponseErrorBody | null;
        const value = body?.[field];

        return typeof value === "string" && value.length > 0 ? value : undefined;
    } catch {
        return undefined;
    }
};
